import React from "react";
import PropTypes from 'prop-types';
import { Button } from "@mui/material";
import "./SolutionArticleSummaryCard.scss";

export default function SolutionArticleSummaryCard(props) {

  const {callToAction, image, title, subtitle, paragraph } = props.data;

  return (
    <div className="card-wrapper">
      <div className="image-container" style={{'--card-image': `url("${image}")`}}></div>
      <div className="content-container">
        <div className="content-group">
          <h3 className="primary-color">{title}</h3>
          <h4>{subtitle}</h4>
          <p>{paragraph}</p>
        </div>
        <div className="action-container">
          {callToAction.map((item, index) => 
              <Button 
                key={index} 
                variant="contained" 
                size="large" 
                className={`btn-sm buttonColor`} onClick={() => props.scrollToElement(item.anchor)}>{item.buttonTitle}</Button>)
          }
        </div>
      </div>
    </div>
  )
}

SolutionArticleSummaryCard.propTypes = {
  data: PropTypes.shape({
    callToAction: PropTypes.array,
    image: PropTypes.string,
    mobileImage: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    paragraph: PropTypes.string,
  })
}
